function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#121212",
  d: "M30.875 35.75L50 54.875 69.125 35.75 75 41.667l-25 25-25-25 5.875-5.917z"
});

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zMC44NzUgMzUuNzUwMkw1MCA1NC44NzUyTDY5LjEyNSAzNS43NTAyTDc1IDQxLjY2NjlMNTAgNjYuNjY2OUwyNSA0MS42NjY5TDMwLjg3NSAzNS43NTAyWiIgZmlsbD0iIzEyMTIxMiIvPgo8L3N2Zz4K";
export { SvgChevron as ReactComponent };